import { Flame, Swords } from "lucide-react";
import CONFIG from "../config";

export const LoreSection = () => {
  return (
    <section data-testid="lore-section" className="relative w-full py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: "url('/assets/hero-bg-7.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.12,
      }} />
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-[#050404] via-transparent to-[#050404]" />

      {/* Fire line divider top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fire-red/40 to-transparent" />

      <div className="relative z-10 px-4 sm:px-6 md:px-12 lg:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-3 mb-8">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-fire-red/60" />
            <Swords className="w-5 h-5 text-fire-red/60" />
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-fire-red/60" />
          </div>

          <h2 data-testid="lore-title" className="font-cinzel text-xl sm:text-2xl md:text-3xl font-bold uppercase tracking-[0.1em] sm:tracking-[0.2em] mb-6 sm:mb-8" style={{ color: "#fff", textShadow: "0 0 30px rgba(220,38,38,0.3)" }}>
            The Legend of the Fire Horse
          </h2>

          <p className="font-manrope text-sm sm:text-base md:text-lg text-muted-foreground/80 leading-relaxed mb-6 max-w-2xl mx-auto">
            In the Chinese Zodiac, the <span className="text-fire-orange font-semibold">Fire Horse</span> is the rarest and most powerful sign.
            Born once every 60 years, it brings unstoppable energy and transformation.
          </p>
          <p className="font-manrope text-sm sm:text-base md:text-lg text-muted-foreground/80 leading-relaxed mb-8 sm:mb-10 max-w-2xl mx-auto">
            <span className="text-fire-red font-semibold">2026 marks the return.</span> {CONFIG.TOKEN_NAME} rises from the ashes with an autonomous
            <span className="text-fire-orange"> Buyback & Burn</span> engine. Every transaction fuels the fire.
            The horse burns everything in its path.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
            <div className="p-5 border border-forge-steel/30 bg-forge-surface/50 backdrop-blur-sm" style={{ borderRadius: "2px" }}>
              <Flame className="w-6 h-6 text-fire-red mx-auto mb-3" />
              <p className="font-cinzel text-sm font-bold uppercase tracking-wider text-foreground mb-1">Auto Buyback</p>
              <p className="font-mono text-[11px] text-muted-foreground/60 leading-relaxed">Creator rewards converted to SOL, used to buy back tokens automatically</p>
            </div>
            <div className="p-5 border border-forge-steel/30 bg-forge-surface/50 backdrop-blur-sm" style={{ borderRadius: "2px" }}>
              <Flame className="w-6 h-6 text-fire-orange mx-auto mb-3" />
              <p className="font-cinzel text-sm font-bold uppercase tracking-wider text-foreground mb-1">Eternal Burn</p>
              <p className="font-mono text-[11px] text-muted-foreground/60 leading-relaxed">Bought-back tokens are permanently burned, reducing supply forever</p>
            </div>
            <div className="p-5 border border-forge-steel/30 bg-forge-surface/50 backdrop-blur-sm" style={{ borderRadius: "2px" }}>
              <Flame className="w-6 h-6 text-fire-ember mx-auto mb-3" />
              <p className="font-cinzel text-sm font-bold uppercase tracking-wider text-foreground mb-1">Deflationary</p>
              <p className="font-mono text-[11px] text-muted-foreground/60 leading-relaxed">Supply decreases with every trade. The fire never stops burning</p>
            </div>
          </div>
        </div>
      </div>

      {/* Fire line divider bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fire-red/40 to-transparent" />
    </section>
  );
};
